import {
    GETVIDEOLIST,
    GETVIDEOCONTEXT,
    GETVIDEOLISTBYTAGS,
    GETVIDEORECOMMENDLIST,
    GETVIDEOHOTLIST,
    GETVIDEOCHANNELS,
    GETVIDEORELATED
} from '../constants/video'
import { formatPublishTime } from 'multiPublic'

const initVideoListData = {
    pageSize: 0,
    recordCount: 0,
    currentPage: 0,
    pageCount: 0,
    inforList: []
}

const initList = {
    // 按频道缓存视频列表，最新频道使用 latest 作为 key
    videoListCache: {},
    // 视频详情
    videoDetail: {
        current: {
            author: '',
            commentCounts: 0,
            content: '',
            coverPic: '',
            createTime: 0,
            createdBy: '',
            hotCounts: 0,
            iconUrl: '',
            id: '',
            nickName: '',
            passportId: '',
            publishTime: 0,
            readCounts: 0,
            role: 0,
            shareLogoPic: '',
            status: 0,
            title: '',
            topOrder: 0,
            updateTime: 0,
            url: '',
            vGrade: 0
        },
        next: {},
        pre: {}
    },
    // 根据标签的推荐视频列表
    videoByTagsListData: {
        pageSize: 0,
        recordCount: 0,
        currentPage: 0,
        pageCount: 0,
        inforList: []
    },
    // 推荐视频列表
    videoRecommendListData: {
        pageSize: 0,
        recordCount: 0,
        currentPage: 0,
        pageCount: 0,
        inforList: []
    },
    // 24H热门视频
    videoHotList: [],
    // 视频频道列表
    videoChannels: [],
    // 相关视频
    videoRelatedList: []
}

export default (state = initList, action) => {
    switch (action.type) {
        case GETVIDEOLIST:
            const cacheKey = action.channelId === null ? 'latest' : String(action.channelId)
            const oldListData = state.videoListCache[cacheKey] || initVideoListData
            const inforList = (action.data.inforList || []).map((item) => ({
                ...item,
                videoTime: formatPublishTime(item.publishTime)
            }))
            const videoListData = {
                ...action.data,
                inforList: action.data.currentPage > 1
                    ? oldListData.inforList.concat(inforList)
                    : inforList
            }
            return {
                ...state,
                videoListCache: {
                    ...state.videoListCache,
                    [cacheKey]: videoListData
                }
            }
        case GETVIDEOCONTEXT:
            return { ...state, videoDetail: action.data }
        case GETVIDEOLISTBYTAGS:
            return { ...state, videoByTagsListData: action.data }
        case GETVIDEORECOMMENDLIST:
            return { ...state, videoRecommendListData: action.data }
        case GETVIDEOHOTLIST:
            return { ...state, videoHotList: action.data || [] }
        case GETVIDEOCHANNELS:
            return { ...state, videoChannels: action.data || [] }
        case GETVIDEORELATED:
            return { ...state, videoRelatedList: action.data || [] }
        default:
            return state
    }
}
